<script setup lang="ts">
    import BaseButton from '@/components/BaseButton.vue';
    import BaseColorPicker from '@/components/BaseColorPicker.vue';
    import { computed, ref, useTemplateRef } from 'vue';
    import { onClickOutside } from '@vueuse/core';

    const model = defineModel<string>({ default: '#000000' });

    const isOpen = ref(false);
    const wrapperRef = useTemplateRef('pickerWrapper');

    onClickOutside(wrapperRef, () => {
        isOpen.value = false;
    });

    const colorStyle = computed(() => {
        return {
            backgroundColor: model.value,
        };
    });

    function toggleVisibility() {
        isOpen.value = !isOpen.value;
    }
</script>
<template>
    <div ref="pickerWrapper">
        <BaseButton
            variant="text"
            class="h-8 w-8"
            @click="toggleVisibility"
        >
            <span class="sr-only"> {{ $t('color_picker') }} </span>
            <span
                class="h-5 w-5 rounded-full border border-border-primary"
                :style="colorStyle"
            ></span>
        </BaseButton>
        <div
            v-if="isOpen"
            class="border-border y-0 absolute right-0 z-10 rounded-md border bg-white"
        >
            <BaseColorPicker v-model="model" />
        </div>
    </div>
</template>
